var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -767.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Direction",
    transform: "translate(2734.000000, 767.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2225998,21.7230894 C18.2186077,20.7190737 18.2186077,19.0900483 19.2225998,18.0860326 L20.3085913,17.0000156 L15.4996289,17.0000156 C14.1216397,17.0000156 12.9996484,18.1210331 12.9996484,19.5000547 L12.9996484,23.0001094 L9.99967188,23.0001094 L9.99967188,19.5000547 C9.99967188,16.4680073 12.4676526,13.9999687 15.4996289,13.9999687 L20.3085913,13.9999687 L19.2225998,12.9139518 C18.2186077,11.9099361 18.2186077,10.2819107 19.2225998,9.27689495 L25.4465512,15.4999922 L19.2225998,21.7230894 Z M31.107507,13.8469664 L18.1546082,0.891763934 C16.9646175,-0.297254645 15.0356325,-0.297254645 13.8466418,0.891763934 L0.891743033,13.8469664 C-0.297247678,15.0359849 -0.297247678,16.9650151 0.891743033,18.1550337 L13.8466418,31.1082361 C15.0356325,32.2972546 16.9646175,32.2972546 18.1546082,31.1082361 L31.107507,18.1550337 C32.2974977,16.9650151 32.2974977,15.0359849 31.107507,13.8469664 L31.107507,13.8469664 Z",
    id: 62
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityDirection);
export default __webpack_public_path__ + "static/media/transport-and-utility-direction.42720e79.svg";
export { ForwardRef as ReactComponent };